// extracted by mini-css-extract-plugin
export var contentBody = "_cw-9";
export var headerImage = "_cw-2";
export var imageButton = "_cw-7";
export var imageButtonIcon = "_cw-8";
export var imageHeader = "_cw-4";
export var imageHeaderText = "_cw-5";
export var imageOverlay = "_cw-3";
export var imageTitle = "_cw-6";
export var imageWrapper = "_cw-1";
export var taskList = "_cw-a";
export var widget = "_cw-0";